import { LegalLayout, H2 } from "@/components/legal/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Informativa sulla privacy" updated="agosto 2025">
      <p>
        La presente informativa descrive come <strong>Sedio</strong> (“Sedio”, “noi”) raccoglie, utilizza e protegge
        i dati personali degli utenti che utilizzano il sito <strong>sedio.it</strong> e l'applicazione Sedio (l'“Applicazione”).
        Sedio è uno strumento pensato per gli amministratori di condominio per gestire la comunicazione con condomini
        e fornitori (email, PEC e WhatsApp) con il supporto dell'intelligenza artificiale.
      </p>

      <H2>Titolare del trattamento</H2>
      <p>Il titolare del trattamento dei dati è <strong>Nenyre group S.r.l.</strong> (P. IVA 05008770231), con sede legale in Via Pisano 7B, società che sviluppa e gestisce Sedio. Per qualsiasi richiesta relativa alla privacy puoi scriverci a <strong>info@nenyre.it</strong> o utilizzare il modulo nella sezione “Contatti” del sito.</p>

      <H2>Quali dati raccogliamo</H2>
      <p>
        Raccogliamo: (a) i dati che ci fornisci volontariamente tramite il modulo "Hai domande?" (email e contenuto del
        messaggio); (b) i dati necessari al funzionamento dell'Applicazione quando
        colleghi i tuoi account (ad esempio messaggi email/PEC e relativi allegati); (c) dati tecnici di navigazione
        strettamente necessari al funzionamento del servizio.
      </p>

      <H2>Cookie e statistiche di navigazione</H2>
      <p>
        Il sito utilizza <strong>Google Analytics 4</strong> per raccogliere statistiche aggregate e anonime sulle visite
        (ad esempio numero di visitatori e pagine viste), al solo scopo di comprendere l'utilizzo del sito e migliorarlo.
        Questi cookie di statistica vengono attivati <strong>solo dopo il tuo consenso</strong>, espresso tramite il banner
        presente sul sito: fino ad allora nessun cookie di tracciamento viene installato. Puoi rifiutare o revocare il
        consenso in qualsiasi momento (cancellando i cookie/dati del sito dal tuo browser). I dati sono trattati da Google
        in qualità di responsabile del trattamento.
      </p>

      <H2>Utilizzo dei dati degli account Google</H2>
      <p>
        Se scegli di collegare un account Google, Sedio richiede l'accesso alla tua casella di posta al solo scopo di
        <strong> leggere, riassumere, classificare e organizzare</strong> i messaggi necessari alla gestione del condominio,
        e per aiutarti a preparare le risposte che tu approvi. L'uso delle informazioni ricevute dalle API di Google
        è conforme alla <strong>Google API Services User Data Policy</strong>, inclusi i requisiti di <strong>Limited Use</strong>.
      </p>
      <p>
        In particolare: non vendiamo i dati; non li utilizziamo per pubblicità; non li condividiamo con terze parti se non
        per fornire o migliorare le funzionalità richieste da te, per motivi di sicurezza o per adempiere a obblighi di legge;
        non consentiamo a esseri umani di leggere i dati se non con il tuo consenso esplicito, per finalità di sicurezza,
        per rispettare la legge o quando i dati sono aggregati e resi anonimi. Puoi revocare in qualsiasi momento l'accesso
        dell'Applicazione dal tuo account Google.
      </p>

      <H2>Finalità e base giuridica</H2>
      <p>
        Trattiamo i dati per: rispondere alle tue richieste di contatto; fornire le funzionalità dell'Applicazione;
        adempiere a obblighi di legge. La base giuridica è il consenso, l'esecuzione di un contratto o servizio da te
        richiesto e il legittimo interesse a fornire e migliorare il servizio.
      </p>

      <H2>Conservazione</H2>
      <p>Conserviamo i dati per il tempo necessario alle finalità indicate e comunque nel rispetto degli obblighi di legge. Puoi chiederne la cancellazione in qualsiasi momento.</p>

      <H2>Condivisione con fornitori</H2>
      <p>
        Possiamo avvalerci di fornitori tecnici (hosting, infrastruttura, servizi di intelligenza artificiale) che
        trattano i dati per nostro conto come responsabili del trattamento, con adeguate garanzie di sicurezza e
        riservatezza, esclusivamente per erogare il servizio.
      </p>

      <H2>I tuoi diritti</H2>
      <p>
        In base al GDPR hai diritto di accedere ai tuoi dati, rettificarli, cancellarli, limitarne il trattamento,
        opporti al trattamento e richiederne la portabilità. Puoi inoltre revocare il consenso in qualsiasi momento e
        proporre reclamo all'autorità di controllo (Garante per la protezione dei dati personali).
      </p>

      <H2>Sicurezza</H2>
      <p>Adottiamo misure tecniche e organizzative adeguate per proteggere i dati da accessi non autorizzati, perdita o divulgazione.</p>

      <H2>Modifiche</H2>
      <p>Potremmo aggiornare questa informativa nel tempo. Le modifiche saranno pubblicate su questa pagina con la relativa data di aggiornamento.</p>

      <H2>Contatti</H2>
      <p>Per esercitare i tuoi diritti o per qualsiasi domanda sulla privacy, contattaci tramite il modulo presente sul sito nella sezione “Contatti”.</p>
    </LegalLayout>
  );
}
